import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export const TimeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (!value) return null; // skip if empty

  // Match strict format HH:mm
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(value);
  if (!match) return { invalidTime: 'Ungültiges Zeitformat (HH:MM erwartet)' };

  return null;
};
